// ============================================================================
// VIDEO NODE — Tiptap block node for embedded <video> playback.
// 1:1 mirror of siena-web/apps/web/components/docs/knowledge/video-node.ts
// kept duplicated because the docs-site is a standalone Vite bundle and the
// editor package isn't published. If you change either copy, update both.
// ============================================================================

import { Node, mergeAttributes } from "@tiptap/core";

export interface VideoOptions {
  HTMLAttributes: Record<string, unknown>;
}

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    video: {
      setVideo: (options: {
        src: string;
        alt?: string | null;
        poster?: string | null;
      }) => ReturnType;
    };
  }
}

export const VideoNode = Node.create<VideoOptions>({
  name: "video",
  group: "block",
  draggable: true,
  selectable: true,
  atom: true,

  addOptions() {
    return {
      HTMLAttributes: { class: "editor-video" }
    };
  },

  addAttributes() {
    return {
      src: { default: null },
      alt: { default: null },
      poster: { default: null }
    };
  },

  parseHTML() {
    return [
      { tag: "video[src]" },
      {
        // <video><source src="…"/></video> form
        tag: "video",
        getAttrs: (el) => {
          if (typeof el === "string") return false;
          const source = (el as HTMLElement).querySelector("source[src]");
          if (!source) return false;
          return {
            src: source.getAttribute("src"),
            alt: (el as HTMLElement).getAttribute("aria-label"),
            poster: (el as HTMLElement).getAttribute("poster")
          };
        }
      }
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "video",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        controls: "true",
        preload: "metadata",
        playsinline: "true"
      })
    ];
  },

  addCommands() {
    return {
      setVideo:
        (options) =>
        ({ commands }) =>
          commands.insertContent({
            type: this.name,
            attrs: options
          })
    };
  }
});
